import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import useStyles from './TrustpilotWidgetContainer.styles';
import TrustpilotWidget from '../../TrustpilotWidget/TrustpilotWidget';
const TrustpilotWidgetContainer = (props) => {
    const { trustpilotBackground, trustPilotDarknessLevel, displayPosition } = props;
    const [trustpilotDarkness, setTrustpilotDarkness] = useState('rgba(255,255,255,100%)');
    useEffect(() => {
        const trustPilotDarknessAttributes = typeof trustPilotDarknessLevel === 'number' ? `rgba(255,255,255, ${trustPilotDarknessLevel}%)` : null;
        trustPilotDarknessAttributes && setTrustpilotDarkness(trustPilotDarknessAttributes);
    }, [trustPilotDarknessLevel]);
    const { classes } = useStyles();
    return (_jsx(Box, { className: clsx(displayPosition === 'TOP' ? classes.overlayTrustpilotWidget : classes.outsideShowTrustpilotWidget), style: { backgroundColor: trustpilotBackground === 'BLACK' ? 'transparent' : trustpilotDarkness }, "data-testid": displayPosition === 'TOP' ? 'trustpilotWidgetTop' : 'trustpilotWidgetBottom', children: _jsx(TrustpilotWidget, { template: "MICRO_STAR", noPointer: true }) }));
};
export default TrustpilotWidgetContainer;
